var map = {
	"./appAsset-brand--khipuLogo.svg": "922b",
	"./appAsset-brand--mercadopagoLogo.svg": "4fb5",
	"./appAsset-brand--paypalLogo.svg": "9b7a",
	"./appAsset-brand--stripeLogo.svg": "fbe7",
	"./appAsset-brand--twocheckoutLogo.svg": "edf9",
	"./appAsset-brand--webpayLogo.svg": "d66d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f15";